import React from 'react';
import { useSelector } from 'react-redux';

import { Box } from '@mui/material';

import { useGetMessagesQuery } from '../chatApi';
import { useGetAppConfigQuery } from 'app/api/mainApi';

import Message from './Message';

const Messages = () => {
  const currentContact = useSelector((state) => {
    return state.nfChat.currentContact;
  });

  const { data: messages } = useGetMessagesQuery({
    selectedUserId: currentContact?.other_user.id,
  }, {
    skip: !currentContact,
  });

  const currentUser = useGetAppConfigQuery().data?.current_user;

  if (!currentContact || !messages) return null;

  const processedMessages = messages.toSorted((messageA, messageB) => {
    return messageA.id - messageB.id;
  });

  return (
    <Box
      sx={{
        margin: '10px',
        overflow: 'scroll',
        height: 'calc(100vh - 350px)',
      }}
    >
      {processedMessages.map((message) => {
        return (
          <Message
            message={message}
            key={message.id}
            currentUserId={currentUser.id}
          />
        );
      })}
    </Box>
  );
};

export default Messages;
